import { Component, Inject } from '@angular/core';
import { MODAL_DATA, NgbActiveModal } from '@agilent/ui-element';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'app-launch-delete-cid-dialog',
    styles: [
        `
            :host .inline-progress > ::ng-deep .loader-overlay {
                background: transparent !important;
                margin: 0;
                padding: 0;
                position: static;
                transform: scale(0.7);
            }

            .progress-text {
                color: var(--agilent-magenta);
                font-weight: 600;
            }

            .action-btn {
                width: 7rem;
            }
        `
    ],
    template: `
        <ag-dialog [header]="dialogTitle">
            <ag-dialog-content>
                <div *ngIf="cidHasPin">
                    <p>
                        STOP!! Are you absolutely sure that you want to delete
                        the CID '{{cidName}}'?
                    </p>
                    <p>
                        Once it is deleted, the CID will no longer be visible
                        in the Hub and it will automatically reset itself to
                        factory settings when rebooted. You should also remove
                        any associated instruments and the instrument
                        controller '{{cidName}}' in OpenLab Control Panel.
                    </p>
                </div>
                <div *ngIf="!cidHasPin">
                    <p>
                        Are you sure that you want to delete the CID '{{cidName}}'?
                    </p>
                </div>
                <app-user-reason-form
                    label="Provide a reason"
                    [maxlength]="255"
                    [disabled]="isLoading"
                    [class.disabled]="isLoading"
                    (formReady)="formIsReady($event)">
                </app-user-reason-form>

                <p *ngIf="warningMessage">
                    <span class="font-weight-bold">WARNING:</span>
                    {{ warningMessage }}
                </p>
            </ag-dialog-content>
            <ag-dialog-actions>
                <span *ngIf="isLoading "
                      class="progress-text">Please wait...</span>
                <ag-loader id="loading-spinner" class="inline-progress"
                           [visible]="isLoading " [small]="true"></ag-loader>
                <ag-button
                    type="secondary"
                    [disabled]="isLoading"
                    [class.disabled]="isLoading"
                    (click)="close()"
                    value="Cancel"
                    id="cancel-btn"
                ></ag-button>
                <ag-button
                    type="primary"
                    [disabled]="isDeleteButtonDisabled()"
                    [class.disabled]="isDeleteButtonDisabled()"
                    (click)="delete()"
                    value="Delete"
                    id="delete-btn"
                ></ag-button>
            </ag-dialog-actions>
        </ag-dialog>
    `
})
export class DeleteCidDialogComponent {
    dialogTitle: string;
    task: any;
    taskArgs: any[];
    isLoading = false;
    warningMessage: string;
    reasonForm: FormGroup;
    cidName: string;
    instrumentWarning = undefined;
    cidHasPin: boolean = true;

    constructor(
        private activeModal: NgbActiveModal,
        @Inject(MODAL_DATA) private modalData: any
    ) {
        this.task = modalData.task;
        this.taskArgs = modalData.taskArgs;
        this.dialogTitle = `Delete CID '${modalData.cid.name}'?`;
        this.cidName = modalData.cid.name;
        this.cidHasPin = !!modalData.cid.pin_code;
    }

    async delete() {
        this.isLoading = true;
        this.taskArgs.push(this.reasonForm.controls['userReason'].value);
        await this.task.call(this, ...this.taskArgs);
        this.activeModal.close();
    }

    close() {
        this.activeModal.dismiss();
    }

    formIsReady(reasonForm: FormGroup) {
        this.reasonForm = reasonForm;
    }

    isDeleteButtonDisabled() {
        return (
            !this.reasonForm.dirty ||
            this.reasonForm.invalid ||
            this.isLoading
        );
    }
}
